import moment from 'moment';
import 'moment/locale/pl';
import localization from 'moment/locale/pl';

export function dateFormat(date, format) {
    return date.lang('pl').format(format);
}